import absoluteUrl from 'next-absolute-url'
import _find from 'lodash/find'

import MetaTags from 'components/MetaTags'

import CategoryService from 'containers/CategoryService'

import { categories } from 'constant/category-landing'
import { getCanonicalUrl } from 'lib/seo'

export default function Index({ canonical, slug }) {
  const data = _find(categories, ['slug', slug])

  const metadata = data?.metadata
  const metaTitle = metadata?.metaTitle
  const metaDescription = metadata?.metaDescription
  const metaImage = metadata?.shareImage?.url
  const metaKeywords = metadata?.keywords
  const canonicalUrl = getCanonicalUrl(canonical)

  return (
    <>
      <MetaTags
        title={metaTitle}
        description={metaDescription}
        pathUrl={canonical}
        image={metaImage}
        keywords={metaKeywords}
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'Service',
          name: metaTitle,
          description: metaDescription,
          url: canonicalUrl,
          provider: {
            '@type': 'Organization',
            name: '24 FIX',
            url: getCanonicalUrl('/'),
          },
          areaServed: { '@type': 'Country', name: 'Thailand' },
        }}
      />

      <CategoryService data={data} />
    </>
  )
}

export async function getServerSideProps(context) {
  const { req, query } = context
  const { origin } = absoluteUrl(req)
  const { slug } = query
  const data = _find(categories, ['slug', slug])

  if (!data) {
    return { notFound: true }
  }

  return {
    props: JSON.parse(
      JSON.stringify({
        canonical: `${origin}/${slug}`,
        slug,
      })
    ),
  }
}
